import { Component, OnInit, OnDestroy } from '@angular/core';
import { Helpers, ThemeService } from 'ngx-elvis-ds';
import { ConfigService } from 'src/app/config.service';
import { ModalController } from '@ionic/angular';
import { GUIService } from 'src/app/gui/gui.service';
import { CartService } from 'src/app/services/cart.service';
import { SAMService } from 'src/app/sam/sam.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { I18NService } from 'src/app/services/i18n.service';

@Component({
  selector: 'app-cart-dialog',
  templateUrl: './cart-dialog.page.html',
  styleUrls: ['./cart-dialog.page.scss'],
})
export class CartDialogPage implements OnInit, OnDestroy {

  constructor(
    public themeSvc: ThemeService,
    public configSvc: ConfigService,
    public cartSvc: CartService,
    public guiSvc: GUIService,
    public i18nSvc: I18NService,
    private modalCtrl: ModalController,
    private sam: SAMService,
  ) {
  }

  ionViewDidEnter() {
  }

  ngOnDestroy() {
  }

  ngOnInit() {
    this.subscribeListeners();
  }

  onDismiss() {
    this.modalCtrl.dismiss(null, null, 'cart-dialog');
  }

  // private

  subscribeListeners() {
    this.sam.channels.gui.subscribe(async (msg: SAMMessage) => {
      if (['CLEAN'].includes(msg.Command)) {
        if (!msg.parms.SkipCartClose) {
          this.onDismiss();
        }
      }
    });
  }

  unsubscribeListeners() {
    this.sam.channels.gui.unsubscribe();
  }

}
